import { render } from "./LeeProfile.vue?vue&type=template&id=80042d90&scoped=true&ts=true"
import script from "./LeeProfile.vue?vue&type=script&lang=ts"
export * from "./LeeProfile.vue?vue&type=script&lang=ts"

import "./LeeProfile.vue?vue&type=style&index=0&id=80042d90&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3623750061/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80042d90"]])

export default __exports__